<script lang="ts">
	import { onMount } from 'svelte';
	import { t } from 'svelte-i18n';
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';

	export let mail = false;
	export let twitter = false;
	export let facebook = false;
	export let linkedin = false;
	export let pageTitle = '';
	export let mailFunction = null;
	export let roundedFull = true;
	export let buttonClassName = '';

	let currentUrl,
		services = [];

	onMount(() => {
		currentUrl = window.location.href;

		twitter &&
			(services = [
				...services,
				{
					iconName: 'twitter',
					url: `https://twitter.com/share?url=${currentUrl}&text=${pageTitle}`
				}
			]);
		facebook &&
			(services = [
				...services,
				{
					iconName: 'facebook',
					url: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}&quote=${pageTitle}`
				}
			]);
		linkedin &&
			(services = [
				...services,
				{
					iconName: 'linkedin',
					url: `http://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${pageTitle}`
				}
			]);
		mail &&
			(services = [
				...services,
				{
					iconName: 'mail',
					action: mailFunction
				}
			]);
	});
</script>

{#if currentUrl}
	{#each services as s}
		<ButtonBoxPrimary
			on:click={s.action}
			props={{
				href: s.url,
				hrefTarget: 'blank',
				iconLeft: s.iconName,
				tooltip: { title: $t(`share.${s.iconName}`), placement: 'top' },
				roundedFull: false,
				classNames: `border border-primary ${buttonClassName}`
			}}
		/>
	{/each}
{/if}
